import React from 'react';
import { Card, CardContent, Typography, Box, List, ListItem } from '@mui/material';
import './RedFlags.css';

const RedFlags = ({ redFlags }) => {
  const flags = redFlags && Array.isArray(redFlags) ? redFlags : [];

  const formatIssue = (s) =>
    (s || '')
      .replace(/\band\b/g, '&')
      .split(' ')
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');

  return (
    <Card className="redFlags-card" sx={{ borderRadius: "12px", boxShadow: "none", border: "none" }}>
      <CardContent className="redFlags-card-content">
        <Typography className="redFlags-title">Red Flags</Typography>
      </CardContent>
      <CardContent className="redFlags-list-content">
        <List>
          {flags.length > 0 ? (
            flags.map((item, index) => (
              <ListItem key={index} className="redFlags-list-item">
                <Box className="redFlags-box">
                  <Typography component="div" className="redFlags-text">
                    {formatIssue(item.issue)}
                  </Typography>
                  <Typography component="div" className="redFlags-timestamp-text">
                    {item.timestamp && item.timestamp !== 'Multiple throughout'
                      ? `Timestamp: ${item.timestamp}`
                      : 'Timestamp: Not specified'}
                  </Typography>
                  <Typography component="div" className="redFlags-context">
                    {item.context || ''}
                  </Typography>
                </Box>
              </ListItem>
            ))
          ) : (
            <Typography className="no-red-flags">No red flags detected</Typography>
          )}
        </List>
      </CardContent>
    </Card>
  );
};

export default RedFlags;